import { Module } from '@nestjs/common';
import { AlertasEmpresaModule } from 'src/alertas-empresa/alertas-empresa.module';
import { NumeracionCrmService } from './common/numeracion-crm.service';
import { CrmConfigController } from './config/crm-config.controller';
import { CrmConfigService } from './config/crm-config.service';
import { CrmPruebaController } from './prueba/crm-prueba.controller';
import { CrmPruebaCron } from './prueba/crm-prueba.cron';
import { CrmPruebaService } from './prueba/crm-prueba.service';
import { CrmSeedService } from './seeds/crm-seed.service';

/**
 * CRM 360. Ver src/crm/CLAUDE.md, docs/spec-crm-360.md y docs/plan-crm-360.md.
 *
 * Fase 0: sólo configuración (M90). Los submódulos de leads, oportunidades,
 * bandeja, tickets y contratos se van sumando acá a medida que avanzan las fases.
 */
@Module({
  imports: [AlertasEmpresaModule],
  controllers: [CrmConfigController, CrmPruebaController],
  providers: [CrmConfigService, CrmPruebaService, CrmPruebaCron, NumeracionCrmService, CrmSeedService],
  exports: [CrmConfigService, CrmPruebaService, NumeracionCrmService, CrmSeedService],
})
export class CrmModule {}
